import React, { useState } from "react";

// Import internal components
import DialogInputQR from "./DialogInputQR";
import DialogDelete from "./DialogDelete";
import DownloadDialog from "./DialogDownload";

// Import external components
import {
    IconButton,
    TableRow,
    TableCell,
    ButtonGroup,
    Tooltip,
    Typography,
} from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import QrCode from "@mui/icons-material/QrCode";

export default function FilledTableRow(props) {
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);
    const [values, setValues] = useState({
        name: props.name,
        targetUrl: props.targetUrl,
    });

    const additionalInfo = "Edit the redirect URL to your liking.";

    const handleDelete = () => {
        props.deleteQR(props.index);
    };

    const handleEdit = (values) => {
        setValues(values);
        props.updateQR(props.index, values);
    }

    const ellipsis = values.targetUrl.length >= 100 ? "..." : ""
    const shortUrl = values.targetUrl.slice(0,100) + ellipsis

    return (
        <>
            <TableRow>
                <TableCell sx={{cursor: "pointer", width: "15%"}} onClick={()=>setDownloadDialogOpen(true)}>{values.name}</TableCell>
                <TableCell sx={{cursor: "pointer", width: "15%"}} onClick={()=>setDownloadDialogOpen(true)}>{props.uid}</TableCell>
                <TableCell sx={{cursor: "pointer", width: '50%'}} onClick={()=>setDownloadDialogOpen(true)}>
                    <Tooltip title={ellipsis ? values.targetUrl : ""}>
                        <Typography variant="body2">
                        {shortUrl}
                        </Typography>
                    </Tooltip>
                </TableCell>
                <TableCell sx={{cursor: "pointer", width: "10%"}} onClick={()=>setDownloadDialogOpen(true)}>{props.createdBy}</TableCell>
                <TableCell sx={{width: "10%"}}>
                    <ButtonGroup>
                        <IconButton onClick={() => setEditDialogOpen(true)}>
                            <Edit />
                        </IconButton>
                        <IconButton onClick={() => setDownloadDialogOpen(true)}>
                            <QrCode />
                        </IconButton>
                        <IconButton onClick={() => setDeleteDialogOpen(true)}>
                            <Delete />
                        </IconButton>
                    </ButtonGroup>
                </TableCell>
            </TableRow>
            <DialogInputQR
                open={editDialogOpen}
                onClose={() => setEditDialogOpen(false)}
                targetUrl={values.targetUrl}
                name={values.name}
                id={props.id}
                edit={true}
                additionalInfo={additionalInfo}
                addNewQR={props.addNewQR}
                updateQR={handleEdit}
            />
            <DialogDelete
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                title={props.name}
                id={props.id}
                handleDelete={handleDelete}
            />
            <DownloadDialog
                targetUrl={window.location.href + "redirect/" + props.uid}
                open={downloadDialogOpen}
                setOpen={setDownloadDialogOpen}
            />
        </>
    );
}
